import React from 'react';

const PinballInstructionsGraphic = () => {
    return (
        <div className="relative w-64 h-48 flex items-center justify-center mb-4">
            <svg viewBox="0 0 200 150" className="w-full h-full drop-shadow-[0_0_10px_rgba(34,211,238,0.3)]">
                {/* Phone Body */}
                <rect x="60" y="10" width="80" height="130" rx="10" fill="#0f172a" stroke="#334155" strokeWidth="2" />

                {/* Screen */}
                <rect x="65" y="15" width="70" height="120" rx="5" fill="#1e293b" />

                {/* Left Touch Zone (Cyan) */}
                <circle cx="65" cy="100" r="15" fill="rgba(34, 211, 238, 0.2)" className="animate-pulse" />
                <path d="M 65 85 L 65 115" stroke="#22d3ee" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
                <path d="M 50 100 L 80 100" stroke="#22d3ee" strokeWidth="2" strokeLinecap="round" opacity="0.5" />

                {/* Right Touch Zone (Pink) */}
                <circle cx="135" cy="100" r="15" fill="rgba(244, 114, 182, 0.2)" className="animate-pulse" style={{ animationDelay: '0.5s' }} />
                <path d="M 135 85 L 135 115" stroke="#f472b6" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
                <path d="M 120 100 L 150 100" stroke="#f472b6" strokeWidth="2" strokeLinecap="round" opacity="0.5" />

                {/* Left Hand/Thumb - Even Rounder */}
                <path
                    d="M 30 110 Q 50 100 60 100 Q 70 100 70 110 Q 70 120 60 125 Q 50 130 40 130"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                {/* Left Fingers wrapping back */}
                <path d="M 60 50 Q 50 50 40 60" fill="none" stroke="#475569" strokeWidth="3" strokeLinecap="round" />
                <path d="M 60 70 Q 50 70 40 80" fill="none" stroke="#475569" strokeWidth="3" strokeLinecap="round" />

                {/* Right Hand/Thumb - Even Rounder */}
                <path
                    d="M 170 110 Q 150 100 140 100 Q 130 100 130 110 Q 130 120 140 125 Q 150 130 160 130"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                {/* Right Fingers wrapping back */}
                <path d="M 140 50 Q 150 50 160 60" fill="none" stroke="#475569" strokeWidth="3" strokeLinecap="round" />
                <path d="M 140 70 Q 150 70 160 80" fill="none" stroke="#475569" strokeWidth="3" strokeLinecap="round" />

                {/* Labels */}
                <text x="40" y="145" fill="#22d3ee" fontSize="8" fontFamily="monospace" textAnchor="middle">LEFT FLIP</text>
                <text x="160" y="145" fill="#f472b6" fontSize="8" fontFamily="monospace" textAnchor="middle">RIGHT FLIP</text>
            </svg>
        </div>
    );
};

export default PinballInstructionsGraphic;
